import { Component, Input, ViewChild } from '@angular/core';
import { GlobalConstants } from '../../../global-constants';
import { MensajesModalComponent } from '../mensajes-modal.component';

@Component({
  selector: 'app-perfil-mensaje',
  templateUrl: './perfil-mensaje.component.html',
  styleUrls: ['./perfil-mensaje.component.css']
})
export class PerfilMensajeComponent {
  @Input() perfil: any = {};
  @Input() botones: boolean = false;

  constructor(public app: MensajesModalComponent) {}

  irPerfil() {
    window.open(GlobalConstants.urlServer + 'perfil/' + this.perfil.slug, '_blank', 'noopener,noreferrer');
  }

}
